import { useState, FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/d70qr2j2m2156g4s7270";

export default function ContactSection() {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("sending");
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="py-24 bg-stone-50">
      <div className="max-w-3xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <span className="inline-block text-teal-700 text-sm font-semibold tracking-widest uppercase mb-3">Contact</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            お問い合わせ
          </h2>
          <div className="w-12 h-0.5 bg-amber-500 mx-auto mb-6" />
          <p className="text-gray-600 text-sm">
            ご不明な点やご相談はお気軽にお問い合わせください。<br />
            担当スタッフより2営業日以内にご返答いたします。
          </p>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 p-8 md:p-10">
          {status === "success" ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-4">
                <i className="ri-check-line text-3xl text-teal-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">送信完了しました</h3>
              <p className="text-gray-500 text-sm">お問い合わせありがとうございます。担当者よりご連絡いたします。</p>
              <button
                onClick={() => setStatus("idle")}
                className="whitespace-nowrap cursor-pointer mt-6 text-teal-700 text-sm underline"
              >
                別のお問い合わせをする
              </button>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              id="contact-form"
              className="space-y-6"
            >
              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                    お名前 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="山田 太郎"
                    className="w-full border border-gray-200 rounded-md px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-teal-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                    電話番号
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="011-000-0000"
                    className="w-full border border-gray-200 rounded-md px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-teal-500 transition-colors"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="example@mail.com"
                  className="w-full border border-gray-200 rounded-md px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-teal-500 transition-colors"
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                  お問い合わせ内容 <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  placeholder="ご質問・ご要望をご記入ください（500文字以内）"
                  className="w-full border border-gray-200 rounded-md px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-teal-500 transition-colors resize-none"
                />
              </div>

              {status === "error" && (
                <p className="text-red-500 text-xs">
                  送信に失敗しました。しばらく経ってから再度お試しください。
                </p>
              )}

              <button
                type="submit"
                disabled={status === "sending"}
                className="whitespace-nowrap cursor-pointer w-full bg-teal-700 hover:bg-teal-800 disabled:bg-gray-300 text-white font-semibold py-3 rounded-md transition-colors text-sm"
              >
                {status === "sending" ? "送信中..." : "送信する"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
